export default {
  LARGE_DESKTOP: 1260,
  DESKTOP: 992,
  TABLET: 768,
  BIG_PHONE: 556,
  PHONE: 376,
};
